/**
 * ShopifyInfiniteScroll - Enhanced version
 * Logic adapted from ChatGPT recommendation for robustness.
 */
class ShopifyInfiniteScroll {
  constructor() {
    this.grid = document.querySelector("#product-grid");
    this.trigger = document.querySelector("#infinite-scroll-trigger");
    // Prefer the dedicated infinite wrapper, fall back to any standard one.
    this.pagination =
      document.querySelector(".pagination-wrapper-infinite") ||
      document.querySelector(".pagination-wrapper");

    if (!this.grid || !this.trigger || !this.pagination) {
      console.log('ShopifyInfiniteScroll: Required elements not found', {
        grid: !!this.grid,
        trigger: !!this.trigger,
        pagination: !!this.pagination
      });
      return;
    }

    this.sectionId = this.grid.dataset.id; // Using data-id from the liquid template
    this.loading = false;
    this.currentPage = this.getCurrentPage();
    this.totalPages = this.getTotalPages();

    this.initObserver();
  }

  getCurrentPage() {
    const params = new URLSearchParams(window.location.search);
    return parseInt(params.get("page")) || 1;
  }

  getTotalPages() {
    const links = this.pagination.querySelectorAll("a[href*='page=']");
    let max = 1;

    links.forEach(link => {
      const url = new URL(link.href, window.location.origin);
      const page = parseInt(url.searchParams.get("page"));
      if (page > max) max = page;
    });

    return max;
  }

  initObserver() {
    const options = {
      rootMargin: "0px 0px 600px 0px" // Slightly larger margin for smoother experience
    };

    if (this.observer) this.observer.disconnect();

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.loading) {
          this.loadNextPage();
        }
      });
    }, options);

    this.observer.observe(this.trigger);
  }

  async loadNextPage() {
    if (this.currentPage >= this.totalPages) {
      if (this.observer) this.observer.disconnect();
      this.trigger.style.display = 'none';
      return;
    }

    this.loading = true;
    this.trigger.style.opacity = '1';

    const nextPage = this.currentPage + 1;
    const url = `${window.location.pathname}?page=${nextPage}&section_id=${this.sectionId}`;

    try {
      const res = await fetch(url);
      if (!res.ok) throw new Error('Fetch failed');
      const text = await res.text();

      const html = new DOMParser().parseFromString(text, "text/html");
      const products = html.querySelectorAll("#product-grid > *");

      if (products.length > 0) {
        products.forEach(p => this.grid.appendChild(p));
        
        // Update URL state
        const newUrl = `${window.location.pathname}?page=${nextPage}${window.location.search.replace(/(\?|&)page=\d+/, '')}`;
        history.replaceState(null, null, newUrl);

        const newPagination = 
          html.querySelector(".pagination-wrapper-infinite") || 
          html.querySelector(".pagination-wrapper");
          
        if (newPagination && this.pagination) {
          this.pagination.innerHTML = newPagination.innerHTML;
        }

        this.currentPage = nextPage;
        
        // Refresh animations if present
        if (window.AOS) window.AOS.refresh();
      } else {
        this.observer.disconnect();
        this.trigger.style.display = 'none';
      }

    } catch (err) {
      console.error("Infinite Scroll Error:", err);
    } finally {
      this.loading = false;
      this.trigger.style.opacity = '0';
    }
  }
}

// Initial initialization
document.addEventListener("DOMContentLoaded", () => {
  window.infiniteScrollInstance = new ShopifyInfiniteScroll();
});

// Re-initialize on facet (filter) rendering
document.addEventListener("facet-rendered", () => {
  window.infiniteScrollInstance = new ShopifyInfiniteScroll();
});

